
<script>
const MAX_USED = 4
export default {
  props: {
    workout: {
      type: Object,
      required: true
    }
  },
  render: function (h) {
    let usedCounter = 0
    let children = []
    let breakMe = false
    for (let [index, el] of this.workout.elements.entries()) {
      children.push([])
      let trip
      if (el.trip_link) {
        trip = <li><v-icon v-tooltip="Miejsce">place</v-icon> <a domPropsHref={el.trip_link} target="_blank">{el.trip_place }</a></li>
      } else {
        trip = <li><v-icon v-tooltip="Miejsce">place</v-icon>{el.trip_place }</li>
      }
      let style = el.element_type.includes('OWB1') ? '' : `style-${this.workout.style}`
      let liarray = [
        [el.with_warmup, <li><i v-tooltip="Rozgrzewka" class="fi flaticon-people-1"></i>{el.warmup || 'Rozgrzewka'}</li>],
        [el.distance, <li class={style}><i v-tooltip="Dystans" class="fi flaticon-road-1"></i> {el.distance }</li>],
        [el.distance_string, <li class={style}><i v-tooltip="Dystans" class="fi flaticon-road-1"></i> {el.distance_string }</li>],
        [el.ascent, <li><v-icon v-tooltip="Podbieg">trending_up</v-icon> {el.ascent }</li>],
        [el.pulse, <li><i v-tooltip="Puls" class="fi flaticon-pulse-line "></i>{el.pulse } bpm</li>],
        [el.pace, <li><i v-tooltip="Tempo" class="fi flaticon-minutes "></i> {el.pace }</li>],
        [el.strength, <li><i v-tooltip="Siła biegowa" class="text-icon ">SB</i> {el.strength }</li>],
        [el.repeats, <li><i v-tooltip="Rytmy" class="text-icon ">R</i> {el.repeats }</li>],
        [el.break_time, <li><i v-tooltip="Przerwa" class="fi flaticon-people "></i> {el.break_time }</li>],
        [el.descent, <li><v-icon v-tooltip="Zbieg">trending_down</v-icon> {el.descent }</li>],
        [el.trip_place, trip],
        [el.with_cooling, <li><i v-tooltip="Schłodzenie" class="text-icon ">C</i> { el.cooling || 'Schłodzenie'}</li>],
        [el.other, <li><v-icon v-tooltip="Inny trening">short_text</v-icon> {el.other}</li>]
      ]
      for (let markup of liarray) {
        if (usedCounter <= MAX_USED) {
          if (markup[0]) {
            children[index].push(markup[1])
            usedCounter++
          }
        } else {
          breakMe = true
          break
        }
      }
      if (breakMe) {
        break
      }
    }
    if (usedCounter > MAX_USED) {
      if (children[children.length - 1].length === 0) {
        children.pop()
        children[children.length - 1].pop()
        children[children.length - 1].pop()
      } else if (children[children.length - 1].length === 1) {
        children.pop()
        children[children.length - 1].pop()
      } else {
        children[children.length - 1].pop()
        children[children.length - 1].pop()
      }
      children[children.length - 1].push(<li class="text-center"><span>...</span></li>)
    }
    let elem = []
    for (let child of children) {
      elem.push(<ul>{child}</ul>)
    }
    return (
      <div>
        {elem}
      </div>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/WorkoutElements.vue